<template>

    <timeregistration
        :can-admin="canAdmin"
        :hours-uri="route('api.v1.hr.timeregistration.index')"
        :process-uri="route('api.v1.hr.timeregistration.store')"
    ></timeregistration>

</template>

<script>

import Timeregistration from "../../components/Projects/Timeregistration";
import {mapGetters} from "vuex";

export default {

    components: {
        Timeregistration,
    },

    computed: {
        ...mapGetters([
            'can',
        ]),

        canAdmin() {
            return this.can('admin', 'timeregistration');
        },
    },

    metaInfo: {
        title:'HR Timeregistration',
    },

    name:'HrTimeregistration',

}

</script>
